package com.example.histoire.web

import kotlin.js.unsafeCast
import kotlin.random.Random
import kotlinx.browser.localStorage
import kotlinx.serialization.Serializable
import kotlinx.serialization.builtins.ListSerializer
import kotlinx.serialization.json.Json

private const val STORAGE_KEY = "histoire_du_soir_child_profiles_v1"

@Serializable
data class StoredChildProfile(
    val id: String,
    val firstName: String,
    val birthDateIso: String,
)

private val json = Json {
    ignoreUnknownKeys = true
    encodeDefaults = true
}

fun loadStoredChildProfiles(): List<StoredChildProfile> =
    try {
        val raw = localStorage.getItem(STORAGE_KEY) ?: return emptyList()
        if (raw.isBlank()) emptyList()
        else json.decodeFromString(ListSerializer(StoredChildProfile.serializer()), raw)
    } catch (_: Throwable) {
        emptyList()
    }

fun saveStoredChildProfiles(profiles: List<StoredChildProfile>) {
    val encoded = json.encodeToString(ListSerializer(StoredChildProfile.serializer()), profiles)
    localStorage.setItem(STORAGE_KEY, encoded)
}

fun newChildProfileId(): String =
    try {
        js("crypto.randomUUID()").unsafeCast<String>()
    } catch (_: Throwable) {
        randomUuidV4Fallback()
    }

private fun randomUuidV4Fallback(): String {
    val c = "0123456789abcdef"
    fun r() = c[Random.nextInt(16)]
    return buildString(36) {
        repeat(8) { append(r()) }
        append('-')
        repeat(4) { append(r()) }
        append('-')
        append('4')
        repeat(3) { append(r()) }
        append('-')
        append(c[8 + Random.nextInt(4)])
        repeat(3) { append(r()) }
        append('-')
        repeat(12) { append(r()) }
    }
}
